// Belantti Variant + Gallery Synchronisation (v4.0)
// Purpose:
// - Keep legacy swatches connected to Shopify OptionSelectors.
// - Move the existing Slick PDP gallery to the selected variant image.
// - Never replace responsive image src/srcset directly.
(function () {
  if (window.__belanttiVariantGalleryV40) return;
  window.__belanttiVariantGalleryV40 = true;

  // Preserve the existing GBP formatting behaviour from v3.3.
  window.money_format = '£{{amount}}';
  if (typeof Shopify === 'object') Shopify.money_format = '£{{amount}}';

  var syncGeneration = 0;

  function parseGalleryIndex(value) {
    if (value === null || typeof value === 'undefined' || value === '') return null;

    var index = parseInt(value, 10);
    if (isNaN(index) || index < 0) return null;

    return index;
  }

  function getMainGallery() {
    if (!window.jQuery) return null;

    var $main = jQuery('.js_prod_main.bel-gallery-main').first();
    if (!$main.length) {
      $main = jQuery('.js_prod_main').first();
    }

    return $main.length ? $main : null;
  }

  function tryMoveGallery(index) {
    if (!window.jQuery || !jQuery.fn || typeof jQuery.fn.slick !== 'function') {
      return false;
    }

    var $main = getMainGallery();
    if (!$main || !$main.hasClass('slick-initialized')) {
      return false;
    }

    try {
      var slick = $main.slick('getSlick');
      if (!slick || typeof slick.slideCount !== 'number' || slick.slideCount < 1) {
        return false;
      }

      if (index >= slick.slideCount) {
        return false;
      }

      $main.slick('slickGoTo', index, true);
      $main.slick('setPosition');
      return true;
    } catch (error) {
      return false;
    }
  }

  function queueGallerySync(value) {
    var index = parseGalleryIndex(value);
    if (index === null) return;

    var generation = ++syncGeneration;
    var delays = [0, 50, 120, 250, 450, 750, 1100, 1500];

    function attempt(attemptIndex) {
      if (generation !== syncGeneration) return;
      if (tryMoveGallery(index)) return;
      if (attemptIndex + 1 >= delays.length) return;

      var wait = delays[attemptIndex + 1] - delays[attemptIndex];
      window.setTimeout(function () {
        attempt(attemptIndex + 1);
      }, wait);
    }

    attempt(0);
  }

  function syncCurrentVariant() {
    queueGallerySync(window.BelanttiCurrentGalleryIndex);
  }

  function dispatchChange(select) {
    var event;

    if (typeof window.Event === 'function') {
      event = new Event('change', { bubbles: true });
    } else {
      event = document.createEvent('HTMLEvents');
      event.initEvent('change', true, false);
    }

    select.dispatchEvent(event);
  }

  function bridgeOption(optionIndex, value) {
    if (isNaN(optionIndex) || optionIndex < 0 || typeof value === 'undefined') return;

    var select = document.getElementById('productSelect-option-' + optionIndex);
    if (!select) return;

    if (select.value !== value) {
      select.value = value;
      dispatchChange(select);
    }
  }

  document.addEventListener('belantti:variant-change', function (event) {
    var detail = event && event.detail ? event.detail : {};
    queueGallerySync(detail.galleryIndex);
  });

  // Radio swatches are the primary PDP selector.
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || radio.type !== 'radio') return;

    var swatch = radio.closest ? radio.closest('.swatch[data-option-index]') : null;
    if (!swatch) return;

    var optionIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
    bridgeOption(optionIndex, radio.value);
  }, true);

  // Retain compatibility with older custom swatch/button markup.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var element = target.closest('.swatch-element[data-value], .product-variant[data-value], .size-item[data-value], .engoj-swatch[data-value]');
    if (!element) return;

    var swatch = element.closest('.swatch[data-option-index]');
    if (!swatch) return;

    var optionIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
    bridgeOption(optionIndex, element.getAttribute('data-value'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCurrentVariant);
  } else {
    syncCurrentVariant();
  }

  window.addEventListener('pageshow', syncCurrentVariant);
})();
